"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HookName = void 0;
var HookName;
(function (HookName) {
    HookName["onLogin"] = "onLogin";
    HookName["entityCreated"] = "entityCreated";
    HookName["entityUpdated"] = "entityUpdated";
    HookName["entityDeleted"] = "entityDeleted";
    HookName["newMessage"] = "newMessage";
    HookName["newConnectionRequest"] = "newConnectionRequest";
    HookName["connectionRequestAccepted"] = "connectionRequestAccepted";
    HookName["connectionRequestRejected"] = "connectionRequestRejected";
    HookName["connectionRequestCompleted"] = "connectionRequestCompleted";
    HookName["connectionRequestArranged"] = "connectionRequestArranged";
    HookName["acceptedOnMembership"] = "acceptedOnMembership";
    HookName["rejectedOnMembership"] = "rejectedOnMembership";
    HookName["appliedOnMembership"] = "appliedOnMembership";
    HookName["bannedOnMembership"] = "bannedOnMembership";
    HookName["completedOnMembership"] = "completedOnMembership";
    HookName["returnedOnMembership"] = "returnedOnMembership";
    HookName["withdrawnOnMembership"] = "withdrawnOnMembership";
    HookName["newCommentReply"] = "newCommentReply";
    HookName["broadcastNotificationToList"] = "broadcastNotificationToList";
    HookName["mention"] = "mention";
    HookName["newDiscussion"] = "newDiscussion";
    HookName["newUserCreatedEntity"] = "newUserCreatedEntity";
    HookName["newApplication"] = "newApplication";
    HookName["abuseReported"] = "abuseReported";
    HookName["appliedOnList"] = "appliedOnList";
    HookName["acceptedOnList"] = "acceptedOnList";
    HookName["rejectedOnList"] = "rejectedOnList";
    HookName["bannedOnList"] = "bannedOnList";
    HookName["completedOnList"] = "completedOnList";
    HookName["returnedOnList"] = "returnedOnList";
    HookName["withdrawnOnList"] = "withdrawnOnList";
})(HookName || (exports.HookName = HookName = {}));
